const getRowsOfTiles = (venues) => {
  const rowsOfTiles = []
  let rowOfTiles = []
  let mutableVenues = venues
  if (mutableVenues.length <= 3) {
    return [mutableVenues]
  }
  mutableVenues.forEach((mutableVenue, i) => {
    rowOfTiles.push(mutableVenue)
    if ((i + 1) % 3 === 0) {
      rowsOfTiles.push(rowOfTiles)
      rowOfTiles = []
    }
  })
  // Push any leftover rowOfTiles chunks onto the list of rowsOfTiles.
  if (rowOfTiles.length > 0) {
    rowsOfTiles.push(rowOfTiles)
  }
  return rowsOfTiles
}

export default getRowsOfTiles
